import { render, staticRenderFns } from "./WsTabsContent.vue?vue&type=template&id=146a36e8&"
import script from "./WsTabsContent.vue?vue&type=script&lang=js&"
export * from "./WsTabsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports